/*
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     状态管理入口
  +--------------------------------------------------------------------------------------
*/

import Vue from 'vue'
import Vuex from 'vuex'
import commonStore from './modules/commonStore'
import expenseStore from './modules/expenseStore'
import fncStore from './modules/fncStore'
import godStore from './modules/godStore'
import memberStore from './modules/memberStore'
import permissionStore from './modules/permissionStore'
import userStore from './modules/userStore'
import rmsStore from './modules/rmsStore'
import devStore from './modules/devStore'
import eiStore from './modules/eiStore'
import getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    commonStore,
    expenseStore,
    fncStore,
    godStore,
    permissionStore,
    userStore,
    rmsStore,
    devStore,
    memberStore,
    eiStore
  },
  getters
})

export default store
